import { api } from '@config/api';
import type { Identidade } from '../types/Identidade';

export const identidadeService = {
  atual: () => api.get<Identidade>('/identidade').then((r) => r.data),
};
